import { HateoasClient } from '@/plugins/hateoas-client'
import { MonthlyHour, MonthlyHourInput } from './interfaces'
export class MonthlyHourApi extends HateoasClient<MonthlyHour, MonthlyHourInput> {
  constructor() {
    super('v1', 'monthlyHours')
  }
}

export const monthlyHourApi = new MonthlyHourApi()
